import { PcApiResponse } from '@/api/pc-api/types';
import { SettleIssuancePeriodType, SettleUnitType } from '@/constants/settle';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type BaseInfo = {
  companyName: string;
  businessNumber: string;
  unitType: keyof typeof SettleUnitType;
};

export type DetailInfo = {
  isSettleTarget: boolean;
  issuancePeriod: keyof typeof SettleIssuancePeriodType;
  name?: string;
  phoneNumber?: string;
  managerEmail?: string;
  managerEmail2?: string;
  managerEmail3?: string;
};

export type SettleBaseInfoForDealerOrPartner = BaseInfo & {
  unitType: 'DEALER' | 'PARTNER';
  detailInfo: DetailInfo;
};

type BaseInfoForSettle = BaseInfo & { unitType: 'SETTLE' };

export const getSettleBaseInfo = () => {
  return api<PcApiResponse<SettleBaseInfoForDealerOrPartner | BaseInfoForSettle>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/settle-base-info`
  );
};
